import type { BlockDefinition, SpacerProps } from '../types';

/**
 * Spacer — invisible vertical whitespace. Useful for:
 *   - Pushing content down so a hero background image bleeds through
 *     behind it (the "I want to see her face" use case).
 *   - Breathing room between sections without a visible line (vs Divider).
 *
 * The block emits an empty div with the configured height. On the live
 * page it's pure whitespace. In the editor, the DraggableBlock wrapper
 * gives it a click + hover outline so the customer can still find +
 * select it.
 */
export const spacer: BlockDefinition<SpacerProps> = {
  type: 'spacer',
  meta: {
    label: 'Spacer',
    icon: '⇕',
    category: 'layout',
    description: 'Invisible vertical space — perfect for showing a hero background through.',
  },
  defaults: () => ({
    height: 64,
  }),
  validate(input) {
    const i = (input ?? {}) as Partial<SpacerProps>;
    let h = typeof i.height === 'number' ? Math.floor(i.height) : 64;
    if (!Number.isFinite(h)) h = 64;
    if (h < 4) h = 4;
    if (h > 600) h = 600;
    return { height: h };
  },
  render(props) {
    return `<div class="pb-block pb-spacer" aria-hidden="true" style="height:${props.height}px;"></div>`;
  },
};
